/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step1_TitleInputs */

const es_landing_step1_title = /** @type {(inputs: Landing_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te registras y pagas la tasa`)
};

const gl_landing_step1_title = /** @type {(inputs: Landing_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexístrate e pagas a tasa`)
};

const en_landing_step1_title = /** @type {(inputs: Landing_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up and pay the fee`)
};

/**
* | output |
* | --- |
* | "Sign up and pay the fee" |
*
* @param {Landing_Step1_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_step1_title = /** @type {((inputs?: Landing_Step1_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step1_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_step1_title(inputs)
	if (locale === "en") return en_landing_step1_title(inputs)
	return es_landing_step1_title(inputs)
});